import React, { Component } from 'react';
import moment from 'moment';
import Header from './Header';
import WeekDays from './WeekDays';
import MonthDates from './MonthDates';
import './Calendar.css';

class Calendar extends Component {
  constructor(props) {
    super(props);
    const date = new Date();
    this.state = {
      year: date.getFullYear(),
      month: date.getMonth(),
      selectedYear: date.getFullYear(),
      selectedMonth: date.getMonth(),
      selectedLocalDate: date.getDate(),
      selectedDate: new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
      ),
      startDay: 1,
      weekNumbers: false,
      minDate: this.props.minDate ? this.props.minDate : null,
      disablePast: this.props.disablePast ? this.props.disablePast : false,
      dayNames: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      monthNames: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      monthNamesFull: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      firstOfMonth: null,
      daysInMonth: null,
    };

    this.getPrev = this.getPrev.bind(this);
    this.getNext = this.getNext.bind(this);
    this.calc = this.calc.bind(this);
    this.selectDate = this.selectDate.bind(this);
  }

  calc(year, month) {
    const { selectedElement, selectedMonth, selectedYear } = this.state;

    if (selectedElement) {
      if (selectedMonth !== month || selectedYear !== year) {
        selectedElement.classList.remove('r-selected');
      } else {
        selectedElement.classList.add('r-selected');
      }
    }
    return {
      firstOfMonth: new Date(year, month, 1),
      daysInMonth: new Date(year, month + 1, 0).getDate(),
    };
  }

  componentWillMount() {
    const { year, month } = this.state;
    this.setState(this.calc(year, month));
  }

  componentDidUpdate(prevProps, prevState) {
    const { onSelect } = this.props;
    const { selectedDate } = this.state;
    if (onSelect && prevState.selectedDate !== selectedDate) {
      onSelect.call(this.getDOMNode(), this.state);
    }
  }

  getPrev() {
    const state = {};
    const { month, year } = this.state;

    if (this.state.month > 0) {
      state.month = month - 1;
      state.year = year;
    } else {
      state.month = 11;
      state.year = year - 1;
    }
    this.setState({ ...state, ...this.calc(state.year, state.month) });
    this.props.close();
  }

  getNext() {
    const state = {};
    const { month, year } = this.state;
    if (this.state.month < 11) {
      state.month = month + 1;
      state.year = year;
    } else {
      state.month = 0;
      state.year = year + 1;
    }

    this.setState({ ...state, ...this.calc(state.year, state.month) });
    this.props.close();
  }

  selectDate(year, month, date, element) {
    const { selectedElement } = this.state;
    if (selectedElement) {
      selectedElement.classList.remove('r-selected');
    }

    element.target.classList.add('r-selected');
    this.setState({
      selectedYear: year,
      selectedMonth: month,
      selectedLocalDate: date,
      selectedDate: new Date(year, month, date),
      selectedElement: element.target,
    });

    this.props.onChange({
      selectedYear: year,
      selectedMonth: month,
      selectedLocalDate: date,
      selectedDate: moment([year, month, date]),
      selectedElement: element.target,
    });
  }

  render() {
    const {
      monthNamesFull,
      month,
      year,
      dayNames,
      startDay,
      weekNumbers,
      daysInMonth,
      firstOfMonth,
      disablePast,
      minDate,
    } = this.state;
    const { getDayStyle } = this.props;

    const headerProps = {
      monthNames: monthNamesFull,
      month,
      year,
      onPrev: this.getPrev,
      onNext: this.getNext,
    };

    const weekDaysProps = {
      dayNames,
      startDay,
      weekNumbers,
    };

    const monthDatesProps = {
      month,
      year,
      daysInMonth,
      firstOfMonth,
      startDay,
      onSelect: this.selectDate,
      weekNumbers,
      disablePast,
      minDate,
      getDayStyle,
    };

    return (
      <div className="r-calendar">
        <div className="r-inner">
          <Header {...headerProps} />
          <WeekDays {...weekDaysProps} />
          <MonthDates {...monthDatesProps} />
        </div>
      </div>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.js